export default __webpack_public_path__ + "media/55db4bf9dd99c2c0ea87ec28d9a6507e.png";